import * as React from 'react';
import './emailChangePane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable } from 'mobx';
import { SideBar } from './SideBar';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { BackButtonHeader } from './BackButtonHeader';
import { EmailChangePaneState } from './states/EmailChangePaneState';
import { FormInput } from '../../atoms/forms/FormInput';
import { CheckBoxInput } from '../../atoms/forms/CheckBoxInput';
import classNames from 'classnames';
import { Loader } from '../../atoms/forms/loader';

type ButtonProps = {
    children: any;
    disabled?: boolean;
    loading: boolean;
    onClick?: () => void;
    className?: string;
};

const Button = observer(({ children, disabled, loading, onClick, className }: ButtonProps) => {
    return (
        <div
            styleName={classNames('button', { disabled: disabled })}
            className={className}
            onClick={!disabled && onClick ? onClick : undefined}
        >
            {loading ? <Loader styleName="loader" /> : children}
        </div>
    );
});

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class EmailChangePane extends React.Component<Props> {
    @observable pageState = new EmailChangePaneState();

    componentDidMount(): void {
        this.pageState.init();
    }

    render() {
        const { submitting, formState } = this.pageState;
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu="email" />}
                <div styleName="main">
                    {GlobalStatesV3.viewport.isSp && <BackButtonHeader to={V3Routes.myPage()} />}
                    <h1 styleName="h1">メールの設定</h1>
                    <div styleName="form-label">メールアドレス</div>
                    <FormInput
                        styleName="email"
                        name="email"
                        value={formState.getValue('email')}
                        placeholder=""
                        onChange={(e) => formState.setValue('email', e.target.value)}
                        error={formState.getError('email')}
                    />
                    <div styleName="form-label">配信設定</div>
                    <CheckBoxInput
                        label={'メールマガジンを許可する'}
                        checked={formState.getValue('receive_promotion_emails')}
                        onCheck={(checked) => formState.setValue('receive_promotion_emails', checked)}
                        error={formState.getError('receive_promotion_emails')}
                        className={'receive-promotion-emails-check-box'}
                    />
                    <div styleName="note">※ キャンペーンやSHEについてのインタビューなどお得な情報をお送りします</div>
                    <div styleName="receive-notification-emails">
                        <CheckBoxInput
                            label={'会員限定のお知らせを許可する'}
                            checked={formState.getValue('receive_notification_emails')}
                            onCheck={(checked) => formState.setValue('receive_notification_emails', checked)}
                            error={formState.getError('receive_notification_emails')}
                            className={'receive-notification-emails-check-box'}
                        />
                    </div>
                    <div styleName="note">※ 最新の特別イベント・教室利用についての重要なお知らせをお送りします</div>
                    <div styleName="form-submit-button">
                        <Button
                            loading={submitting}
                            onClick={() => this.pageState.submit()}
                            className="form-submit-button"
                        >
                            保存する
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
